import { g as getSanitizedIcon } from './getSanitizedIcon-CIZy47UD.js';
import { g as getSVGTransformer } from './getSVGTransformer-B7bLKhPG.js';

/* eslint-disable id-length */


/** Returns the path */
const getIconPath = (pathData, transform) => {
  if (Array.isArray(pathData)) {
    let pathBuilder = '';
    pathData.forEach(path => {
      pathBuilder += `<path ${transform ? `transform="${transform}"` : ''} fill="currentColor" d="${path}" />`;
    });
    return pathBuilder;
  }
  return `<path ${transform ? `transform="${transform}"` : ''} fill="currentColor" d="${pathData}" />`;
};

/** Either returns the Group if a transform exists or just the path */
const getIconGroup = (path, transformer) => {
  if (transformer) {
    const {
      outer: {
        transform: outerTransform
      },
      inner: {
        transform: innerTransform
      },
      path: {
        transform: pathTransform
      }
    } = transformer;
    return `<g transform="${outerTransform}"><g transform="${innerTransform}">${getIconPath(path, pathTransform)}</g></g>`;
  }
  return getIconPath(path);
};
const getIconInternals = (name, path) => {
  if (name === 'spinner') {
    return `<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />${path}`;
  }
  return path;
};

/** Returns the SVG as a string */
const renderIconSVG = (iconDef, transform, className) => {
  const {
    prefix,
    iconName,
    icon
  } = iconDef;
  const {
    height,
    width,
    path
  } = getSanitizedIcon(icon);
  const transformer = getSVGTransformer(width, transform);
  const internals = getIconInternals(iconName, getIconGroup(path, transformer));
  return `<svg aria-hidden="true" fill="none" viewBox="0 0 ${width} ${height}" class="${className} ${prefix} fa-${iconName}" data-fa-i2svg>${internals}</svg>`;
};

export { renderIconSVG as r };
//# sourceMappingURL=renderIconSVG-fObqPj4k.js.map
